import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ChangeAssetCategoryMain } from './ChangeAssetCategoryMain'
import { ChangeAssetCategoryDetail } from './ChangeAssetCategoryDetail/ChangeAssetCategoryDetail'
import { ChangeAssetCategoryForm } from './ChangeAssetCategoryForm/ChangeAssetCategoryForm'

const changeAssetCategoryRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */

  {
    props: {
        exact: true,
        path: '/fixed-assets/:CompanyID/assets-change/change-asset-category/filter',
    },
    component: (
        <AdvancedFilter
            mode="assets-change"
            app="fixed-assets"
            hasStatus
            hasDocDate
            hasDateRange
        />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
        exact: true,
        path: '/fixed-assets/:CompanyID/assets-change/change-asset-category',
    },
    component: <ChangeAssetCategoryMain/>,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

    {
      props: {
        exact: true,
        path: '/fixed-assets/:CompanyID/assets-change/change-asset-category/add',
      },
      component: <ChangeAssetCategoryForm formMode="add" type="ASSETS_REGISTRATION" />,
    },
    {
      props: {
        exact: true,
        path:
          '/fixed-assets/:CompanyID/assets-change/change-asset-category/:ChangeAssetCategoryID/edit',
      },
      component: <ChangeAssetCategoryForm formMode="edit" />,
    },
    {
      props: {
        exact: true,
        path:
          '/fixed-assets/:CompanyID/assets-change/change-asset-category/:ChangeAssetCategoryID/approve-reject',
      },
      component: <ChangeAssetCategoryForm formMode="approve-reject" />,
    },
    {
      props: {
        exact: true,
        path:
          '/fixed-assets/:CompanyID/assets-change/change-asset-category/:ChangeAssetCategoryID/resubmit',
      },
      component: <ChangeAssetCategoryForm formMode="resubmit" />,
    },

    /* -------------------------------------------- */
    /*                    DETAIL                    */
    /* -------------------------------------------- */

    {
        props: {
        exact: true,
        path:
            '/fixed-assets/:CompanyID/assets-change/change-asset-category/:ChangeAssetCategoryID/detail',
        },
        component: <ChangeAssetCategoryDetail />,
    },
]

export default changeAssetCategoryRoutes
